import { DataToJSON, FieldType } from '../../../data-set/interface';
function processAxiosConfig(axiosConfig = {}, args) {
    if (typeof axiosConfig === 'function') {
        return axiosConfig({ ...args });
    }
    return axiosConfig;
}
function getTransportConfig(props) {
    const { config, type, searchCode, queryDataSet, tableFilterAdapter } = props;
    return processAxiosConfig(tableFilterAdapter, { type, config, searchCode, queryDataSet });
}
export const ConditionDataSet = () => ({
    paging: false,
    fields: [
        {
            name: 'fieldName',
            type: FieldType.string,
        },
        {
            name: 'comparator',
            type: FieldType.string,
            defaultValue: 'EQUAL',
        },
        {
            name: 'value',
            transformRequest: value => {
                if (typeof value === 'object') {
                    return JSON.stringify(value);
                }
                return value;
            },
            transformResponse: value => {
                try {
                    return JSON.parse(value);
                }
                catch (e) {
                    return value;
                }
            },
        },
    ],
    dataToJSON: DataToJSON.all,
    events: {
        update: () => {
        },
    },
});
export const QuickFilterDataSet = ({ searchCode, queryDataSet, tableFilterAdapter }) => ({
    paging: false,
    autoQuery: false,
    primaryKey: 'searchId',
    transport: {
        adapter: (config, type) => getTransportConfig({
            config,
            type,
            searchCode,
            queryDataSet,
            tableFilterAdapter,
        }),
    },
    fields: [
        { name: 'searchName', type: 'string', maxLength: 20, required: true },
        { name: 'searchId', type: 'string' },
        { name: 'defaultFlag', type: 'boolean', falseValue: 0, trueValue: 1 },
        { name: 'searchCode', type: 'string', defaultValue: searchCode },
        { name: 'conditionList', type: 'object' },
    ],
});
